import { render, staticRenderFns } from "./RootFooter.vue?vue&type=template&id=22894287&scoped=true&"
import script from "./RootFooter.vue?vue&type=script&lang=js&"
export * from "./RootFooter.vue?vue&type=script&lang=js&"
import style0 from "./RootFooter.vue?vue&type=style&index=0&id=22894287&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22894287",
  null
  
)

export default component.exports